// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2G9zU","sendOtp":"AuthorizeToLogin_sendOtp__1Abuf"};